import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/departements', { params });
  },
  detail(id) {
    return axios.get(`/v1/departements/${id}`);
  },
  create(data) {
    return axios.post('/v1/departements', data);
  },
  update(id, params) {
    return axios.put(`/v1/departements/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/departements/${id}`);
  }
};
